import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-gray-900" data-id="element-38">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-39">
        <div className="max-w-5xl mx-auto mb-8" data-id="element-40"></div>

        <div className="text-sm text-gray-500" data-id="element-41">
          Copyright © 2026 Tomás Benavidez
        </div>
      </div>
    </footer>;
}